import React from 'react';

const AboutUs = () => {
  return (
    <>
      <style>{`
        :root {
          --primary: #6366f1;
          --primary-dark: #4f46e5;
          --secondary: #0f172a;
          --text-main: #1e293b;
          --text-light: #64748b;
          --bg-light: #f8fafc;
          --white: #ffffff;
          --shadow-sm: 0 1px 3px rgba(0,0,0,0.1);
          --shadow-lg: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
        }

        .about-page {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          color: var(--text-main);
          line-height: 1.6;
          overflow-x: hidden;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* --- Hero Section --- */
        .hero-section {
          background: radial-gradient(circle at top right, #4f419cde, transparent),
                      radial-gradient(circle at bottom left, #9182e6c7, transparent),
                      var(--secondary);
          padding: 120px 0 100px;
          text-align: center;
          color: var(--white);
          position: relative;
        }

        .hero-badge {
          background: rgba(255, 255, 255, 0.1);
          padding: 8px 20px;
          border-radius: 99px;
          font-size: 0.875rem;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 24px;
          display: inline-block;
          border: 1px solid rgba(255,255,255,0.2);
          backdrop-filter: blur(4px);
        }

        .hero-title {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 800;
          letter-spacing: -0.02em;
          margin-bottom: 24px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          color: #94a3b8;
          max-width: 800px;
          margin: 0 auto;
        }

        /* --- Content Blocks --- */
        .section-padding {
          padding: 100px 0;
        }

        .grid-2 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        .image-wrapper {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: var(--shadow-lg);
        }

        .glass-box {
          background: linear-gradient(135deg, var(--primary), var(--primary-dark));
          height: 400px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 1.5rem;
          position: relative;
        }

        .glass-box::after {
            content: "";
            position: absolute;
            inset: 0;
            background: url("https://www.transparenttextures.com/patterns/carbon-fibre.png");
            opacity: 0.1;
        }

        .section-tag {
          color: var(--primary);
          font-weight: 700;
          text-transform: uppercase;
          font-size: 0.875rem;
          margin-bottom: 12px;
          display: block;
        }

        .section-heading {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: var(--secondary);
        }

        .text-content p {
          color: var(--text-light);
          font-size: 1.1rem;
          margin-bottom: 20px;
        }

        /* --- Values Section --- */
        .values-bg {
          background-color: var(--bg-light);
          border-radius: 50px;
          margin: 0 20px;
        }

        .values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 32px;
          margin-top: 60px;
        }

        .value-card {
          background: var(--white);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .value-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 30px 60px -12px rgba(0,0,0,0.1);
          border-color: var(--primary);
        }

        .icon-box {
          width: 64px;
          height: 64px;
          background: #6366f115;
          color: var(--primary);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.75rem;
          margin-bottom: 24px;
        }

        .value-card h3 {
          font-size: 1.5rem;
          margin-bottom: 16px;
          font-weight: 700;
        }

        /* --- Responsive --- */
        @media (max-width: 968px) {
          .grid-2 {
            grid-template-columns: 1fr;
            gap: 48px;
          }
          .reverse-mobile {
            direction: rtl;
          }
          .reverse-mobile > * {
            direction: ltr;
          }
          .section-heading {
            font-size: 2rem;
          }
        }

        @media (max-width: 640px) {
          .hero-section {
            padding: 80px 0 60px;
          }
          .values-bg {
            margin: 0;
            border-radius: 0;
          }
        }

        /* Entrance Animation */
        @keyframes reveal {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .reveal {
          animation: reveal 0.8s ease forwards;
        }
      `}</style>

      <div className="about-page">
        {/* Hero Section */}
      <section className="hero-section">
  <div className="container">
    <span className="hero-badge reveal">Your Business. More Visibility. Bigger Growth.</span>
    <h1 className="hero-title reveal">
      Empowering Indian Commerce <br/> For Tomorrow.
    </h1>
    <p className="hero-subtitle reveal">
      MSZILA is your gateway to India’s thriving marketplace — helping local businesses
      connect with customers, grow their reach, and flourish in the digital economy.
      Join thousands of sellers expanding their footprint every day.
    </p>
  </div>
</section>

        {/* Mission Section */}
        <section className="section-padding">
          <div className="container">
            <div className="grid-2">
              <div className="text-content reveal">
                <span className="section-tag">Our Mission</span>
                <h2 className="section-heading">Architecting Excellence in Every Line of Code</h2>
                <p>
                  At ICAME, we believe in creating web applications that prioritize security, 
                  performance, and user experience. Our mission is to provide developers and 
                  businesses with a robust platform that scales effortlessly.
                </p>
                <p>
                  We don't just build software; we build foundations for the next 
                  generation of digital enterprises.
                </p>
              </div>
              <div className="image-wrapper reveal" style={{ animationDelay: '0.2s' }}>
                <div className="glass-box">MISSION & STRATEGY</div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision Section */}
        <section className="section-padding values-bg">
          <div className="container">
            <div className="grid-2 reverse-mobile">
              <div className="image-wrapper reveal">
                <div className="glass-box" style={{ filter: 'hue-rotate(45deg)' }}>FUTURE VISION</div>
              </div>
              <div className="text-content reveal">
                <span className="section-tag">Our Vision</span>
                <h2 className="section-heading">A Secure Digital Future for Everyone</h2>
                <p>
                  We envision a world where secure, scalable web applications are accessible 
                  to everyone. Through continuous innovation and adherence to best practices, 
                  we aim to set the global standard for modern web development.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="section-padding">
          <div className="container">
            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
              <span className="section-tag">Core Principles</span>
              <h2 className="section-heading">Values That Define Us</h2>
            </div>
            
            <div className="values-grid">
              {[
                { icon: '🛡️', title: 'Security First', desc: 'Implementing industry-leading protocols to stay ahead of emerging digital threats.' },
                { icon: '✨', title: 'Innovation', desc: 'Continuously exploring new technologies to deliver cutting-edge web solutions.' },
                { icon: '💎', title: 'Quality', desc: 'Maintaining rigorous standards in code, testing, and comprehensive documentation.' },
                { icon: '🎯', title: 'User-Centric', desc: 'Every decision is guided by the impact on the end user’s experience and success.' }
              ].map((val, i) => (
                <div className="value-card reveal" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                  <div className="icon-box">{val.icon}</div>
                  <h3>{val.title}</h3>
                  <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;